import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import roosterImg from '../rooster.png';

const RoosterAnimation = ({ onComplete }) => {
  const [showAnimation, setShowAnimation] = useState(true);
  const [phase, setPhase] = useState('box-spin-in'); // 'box-spin-in', 'rooster-spin-in', 'pause', 'box-spin-out', 'rooster-fly'

  useEffect(() => {
    // Phase 1: Box spins in (0-0.6s)
    const boxSpinTimer = setTimeout(() => {
      setPhase('rooster-spin-in');
    }, 600);

    // Phase 2: Rooster spins in next to box (0.6-1.2s)
    const roosterSpinTimer = setTimeout(() => {
      setPhase('pause');
    }, 1200);

    // Phase 3: Pause (1.2-1.8s)
    const pauseTimer = setTimeout(() => {
      setPhase('box-spin-out');
    }, 1800);

    // Phase 4: Box spins out (1.8-2.2s)
    const boxOutTimer = setTimeout(() => {
      setPhase('rooster-fly');
    }, 2200);

    // Phase 5: Rooster flies to navbar and complete (2.2-3.5s)
    const completeTimer = setTimeout(() => {
      setShowAnimation(false);
      if (onComplete) onComplete();
    }, 3500);

    return () => {
      clearTimeout(boxSpinTimer);
      clearTimeout(roosterSpinTimer);
      clearTimeout(pauseTimer);
      clearTimeout(boxOutTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  if (!showAnimation) return null;

  return (
    <AnimatePresence>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: 9999,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          pointerEvents: 'none',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {/* Box Emoji */}
        {phase !== 'rooster-fly' && (
          <motion.div
            initial={{ scale: 0, rotate: -360, opacity: 0 }}
            animate={
              phase === 'box-spin-out'
                ? { scale: 0, rotate: 360, opacity: 0 }
                : { scale: 1, rotate: 0, opacity: 1 }
            }
            transition={
              phase === 'box-spin-out'
                ? { duration: 0.4, ease: 'easeIn' }
                : { duration: 0.6, ease: 'easeOut' }
            }
            style={{
              fontSize: '150px',
              marginRight: phase === 'box-spin-in' ? '0' : '50px',
            }}
          >
            📦
          </motion.div>
        )}

        {/* Rooster */}
        {phase !== 'box-spin-in' && (
          <motion.img
            src={roosterImg}
            alt="Rooster"
            initial={{ 
              scale: 0,
              rotate: -360,
              opacity: 0,
            }}
            animate={
              phase === 'rooster-fly'
                ? {
                    // Fly to navbar
                    x: 'calc(-50vw + 70px)',
                    y: 'calc(-50vh + 60px)',
                    scale: 0.5,
                    rotate: 0,
                    opacity: 1,
                  }
                : {
                    // Spin in and stay
                    scale: 1,
                    rotate: 0,
                    opacity: 1,
                  }
            }
            transition={
              phase === 'rooster-fly'
                ? { duration: 1.3, ease: [0.43, 0.13, 0.23, 0.96] }
                : { duration: 0.6, ease: 'easeOut' }
            }
            style={{
              width: '120px',
              height: 'auto',
            }}
          />
        )}
      </Box>
    </AnimatePresence>
  );
};

export default RoosterAnimation;
